import { PlanTab } from '../../../../../components/verification/SubscriptionStep';
import { SubscriptionTerm } from '../../../../../services/exports/Constants';

export default {
  sections: {
    term: {
      description:
        'Facturado mensualmente. El plazo anual es un compromiso de duración, no de frecuencia de facturación.',
      options: {
        [SubscriptionTerm.Monthly]: 'Plazo mensual',
        [SubscriptionTerm.Annual]: 'Plazo anual',
      },
    },
    plans: {
      tabs: {
        [PlanTab.actual]: {
          name: 'Modelo de precio',
          title: 'Escala de precios basada en el éxito',
        },
        [PlanTab.legacy]: {
          name: 'Heredado',
          title: 'Planes',
        },
      },
    },
    add_ons: {
      title: 'Hazte Pro con nuestros complementos para tu Plan Esencial',
      description: 'Atrae nuevos clientes y fomenta visitas repetidas con estas soluciones de software.',
    },
  },
  labels: {
    recommended: 'Recomendado',
    basket: 'Cesta: <strong>{{amount}}</strong> por mes',
  },
  buttons: {
    review_and_subscribe: 'Revisar y suscribirse',
    cancel: 'Cancelar',
    basket: 'Volver a la cesta',
    subscribe: 'Suscribirse',
    update_subscription: 'Actualizar suscripción',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos',
    failed_to_save_contract: 'Error al guardar el contrato de servicio',
    failed_to_create_subscription: 'Error al crear la suscripción',
    subscription_created: 'La suscripción se creó correctamente',
    subscription_updated: 'La suscripción se actualizó correctamente',
  },
};
